var helperCreateInInObjectString = require('./helperCreateInInObjectString')

/**
  * 判断是否Date对象
  *
  * @param {Object} obj 对象
  * @return {Boolean}
  */
var isDate = helperCreateInInObjectString('Date')

module.exports = isDate



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/isDate.js
// module id = j5PO
// module chunks = 137